import { Injectable } from '@angular/core';
import { IEnvironment, IEnvironmentService } from '@nimbus-library/features/configuration/i-environment.service';
import { environment } from './environment';

@Injectable()
export class EnvironmentAdminService extends IEnvironmentService {
  public get environment(): IEnvironment {
    return environment;
  }
}
